export class BaoProductForm extends HTMLElement {
  constructor () {
    super()

    this._onSubmit = this.onSubmitHandler.bind(this)
  }

  connectedCallback () {
    if (this._initialized) return
    this._initialized = true

    this.form = this.querySelector('form')
    if (!this.form) {
      console.error('bao-product-form must wrap a product <form> element')
      return
    }

    const idInput = this.form.querySelector('[name="id"]')
    if (idInput) idInput.disabled = false

    this.submitButton = this.querySelector('[type="submit"]')
    this.hideErrors = this.dataset.hideErrors === 'true'
    this.errorMessageWrapper = this.querySelector(
      '.product-form__error-message-wrapper',
    )
    this.errorMessage = this.errorMessageWrapper?.querySelector(
      '.product-form__error-message',
    )

    this.form.addEventListener('submit', this._onSubmit)
  }

  disconnectedCallback () {
    this.form?.removeEventListener('submit', this._onSubmit)
  }

  async onSubmitHandler (evt) {
    evt.preventDefault()

    if (this.submitButton?.getAttribute('aria-disabled') === 'true') return

    const formData = new FormData(this.form)
    const variantId = formData.get('id')

    const sizeFieldset = document.querySelector(
      'product-info variant-radios #Size, variant-radios #Size',
    )
    const sizeInputs = sizeFieldset
      ? sizeFieldset.querySelectorAll('input[type="radio"][name="Size"]')
      : []
    const sizeSelected =
      sizeInputs.length > 0
        ? Array.from(sizeInputs).some((input) => input.checked)
        : false

    if (
      !variantId ||
      variantId === '' ||
      (sizeInputs.length > 0 && !sizeSelected)
    ) {
      this.handleErrorMessage('Please select a size')
      this.setLoading(false)
      return
    }

    this.handleErrorMessage()

    const sendOnField = document.querySelector('input[name="properties[Send on]"]')
    if (sendOnField) {
      const selectedDate = new Date(sendOnField.value)
      const today = new Date()
      today.setHours(0, 0, 0, 0)

      if (selectedDate < today) {
        sendOnField.setAttribute('aria-invalid', 'true')
        return
      }
    }

    this.setLoading(true)
    this.error = false

    try {
      const state = await window.BAO.Cart.addItemFromForm(this.form)

      if (!state) return

      if (typeof publish !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'product-form',
          productVariantId: formData.get('id'),
          cartData: state,
        })
      }

      const quickAddModal = this.closest('quick-add-modal')
      if (quickAddModal) {
        quickAddModal.hide(true)
      }
    } catch (e) {
      console.error(e)
    } finally {
      this.setLoading(false)

      const cartDrawerWrapper = document.querySelector('cart-drawer')
      if (
        cartDrawerWrapper?.classList.contains('is-empty') &&
        cartDrawerWrapper?.classList.contains('ob-cart-empty')
      ) {
        removeCartDrawerClasses(cartDrawerWrapper, ['is-empty', 'ob-cart-empty'])
      }
    }
  }

  setLoading (isLoading) {
    if (!this.submitButton) return

    if (isLoading) {
      this.submitButton.setAttribute('aria-disabled', 'true')
      this.submitButton.classList.add('loading')
      this.querySelector('.loading__spinner')?.classList.remove('hidden')
    } else {
      this.submitButton.classList.remove('loading')
      if (!this.error) this.submitButton.removeAttribute('aria-disabled')
      this.querySelector('.loading__spinner')?.classList.add('hidden')
    }
  }

  handleErrorMessage (errorMessage = false) {
    const addErrorBorder = document.querySelector(
      'product-info variant-radios #Size',
    )
    const addSizeInput = document.querySelector(
      'product-info variant-radios #Size input',
    )
    const addBtn = this.querySelector(
      '.product-form__buttons .product-form__submit span',
    )

    if (addSizeInput) {
      addSizeInput.addEventListener('click', () => this.removeErrorBorder(), {
        once: true,
      })
    }

    const giftAddBtn = this.form.querySelector("input[name='gift-card']")

    if (giftAddBtn?.value === 'yes') {
      const variantDropdown = document.querySelector(
        'variant-selects .select select',
      )
      if (variantDropdown) {
        variantDropdown.addEventListener('click', () => this.removeErrorBorder(), {
          once: true,
        })
      }
      if (variantDropdown?.value === '') {
        variantDropdown.style.border = '2px solid #EB333D'
        errorMessage = 'This field is required'
        if (this.errorMessage) this.errorMessage.textContent = errorMessage
      }
    }

    if (this.hideErrors) return
    if (!this.errorMessageWrapper) return

    this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage)

    if (errorMessage) {
      if (this.errorMessage) this.errorMessage.textContent = errorMessage
      if (addErrorBorder) addErrorBorder.style.borderBottom = '2px solid #EB333D'
      if (addBtn) {
        addBtn.textContent = 'Please select a size'
        this.querySelector('.product-form__buttons .product-form__submit')?.setAttribute(
          'disabled',
          true,
        )
      }
    }
  }

  removeErrorBorder () {
    const addErrorBorder = document.querySelector(
      'product-info variant-radios #Size',
    )
    if (addErrorBorder) addErrorBorder.style.borderBottom = 'unset'

    const addBtn = this.querySelector(
      '.product-form__buttons .product-form__submit span',
    )
    const submitButton = this.querySelector(
      '.product-form__buttons .product-form__submit',
    )

    if (addBtn && submitButton) {
      addBtn.textContent =
        submitButton.getAttribute('data-add-to-cart-text') || addBtn.textContent
      submitButton.removeAttribute('disabled')
    }

    const variantDropdown = document.querySelector('variant-selects .select select')
    if (variantDropdown) variantDropdown.style.border = '1px solid #bdbdbd'
  }
}

if (!customElements.get('bao-product-form')) {
  customElements.define('bao-product-form', BaoProductForm)
}
